const downloadFile = (content, filename) => {
  // 创建隐藏的可下载链接
  var eleLink = document.createElement("a");
  eleLink.download = filename;
  eleLink.style.display = "none";

  // 字符内容转变成blob地址
  var blob = new Blob([content]);
  eleLink.href = URL.createObjectURL(blob);
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
};
const downloadFileByUrl = (url) => {
  // 创建隐藏的可下载链接
  console.log(url);
  var eleLink = document.createElement("a");
  eleLink.style.display = "none";

  // 字符内容转变成blob地址
  eleLink.href = url;
  // 触发点击
  document.body.appendChild(eleLink);
  eleLink.click();
  // 然后移除
  document.body.removeChild(eleLink);
};

export default downloadFile;

export { downloadFileByUrl };
